module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"panel\"> <div class=\"input-group has-feedback-left\"> <span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span></span> <input type=\"text\" class=\"form-control form-control-lg\" id=\"carrier-type-name-filter\" placeholder=\"Filter by Name\"> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/carrier_type_filter.ejs
// module id = 877
// module chunks = 1